// athlete-eyebrow-numbering.js
// Walks every eyebrow with [data-eyebrow-label] in DOM order, scoped per
// "numbering group", and assigns sequential "0N / Label". Decouples displayed
// numbers from source order so any auto-hidden section can't gap the sequence.
//
// Three groups are walked independently:
//   - .athlete-section-number  (athlete pages — Pattern #3 canonical)
//   - .science-article-section__eyebrow  (ingredient education pages)
//   - .product-page__eyebrow  (THRUX product page)
// Each page only renders one group, so independent walks behave identically
// to the single-group case.

(function () {
  var SELECTORS = [
    '.athlete-section-number[data-eyebrow-label]',
    '.science-article-section__eyebrow[data-eyebrow-label]',
    '.product-page__eyebrow[data-eyebrow-label]'
  ];

  function applyNumbers() {
    SELECTORS.forEach(function (sel) {
      var eyebrows = document.querySelectorAll(sel);
      for (var i = 0; i < eyebrows.length; i++) {
        var el = eyebrows[i];
        var n = String(i + 1).padStart(2, '0');
        var label = el.getAttribute('data-eyebrow-label') || '';
        el.textContent = n + ' / ' + label;
        el.setAttribute('data-eyebrow-ready', '');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyNumbers);
  } else {
    applyNumbers();
  }
})();
